import { useState, useRef, useEffect } from 'react'
import { createPortal } from 'react-dom'
import api from '../services/api'
import { useListaFlutuante } from '../hooks/useListaFlutuante'

interface CentroCusto {
  ccu_cod: string
  ccu_des: string
}

interface Props {
  value: string
  onChange: (cod: string, des: string) => void
}

export default function CentroCustoSelect({ value, onChange }: Props) {
  const [aberta, setAberta] = useState(false)
  const [filtro, setFiltro] = useState('')
  const [lista, setLista] = useState<CentroCusto[]>([])
  const [localCod, setLocalCod] = useState(value)
  const [aviso, setAviso] = useState('')
  const ref = useRef<HTMLDivElement>(null)
  const { posicao, listaRef } = useListaFlutuante(ref, aberta, () => setAberta(false))

  useEffect(() => { setLocalCod(value); if (value) setAviso('') }, [value])

  useEffect(() => {
    api.get('/erp/ccucad').then(r => setLista(r.data)).catch(() => setLista([]))
  }, [])

  const selecionado = lista.find(c => c.ccu_cod === value)

  const filtrada = lista.filter(c => {
    if (!filtro) return true
    const t = filtro.toLowerCase()
    return c.ccu_cod.toLowerCase().includes(t) || c.ccu_des.toLowerCase().includes(t)
  })

  function selecionar(c: CentroCusto) {
    onChange(c.ccu_cod, c.ccu_des)
    setLocalCod(c.ccu_cod)
    setAviso('')
    setAberta(false)
    setFiltro('')
  }

  function handleCodBlur() {
    if (!localCod) { onChange('', ''); setAviso(''); return }
    const encontrado = lista.find(c => c.ccu_cod === localCod)
    if (encontrado) {
      onChange(localCod, encontrado.ccu_des)
      setAviso('')
      setAberta(false)
    } else {
      onChange('', '')
      setAviso(`Código "${localCod}" não encontrado`)
    }
  }

  return (
    <div className="nat-wrap" ref={ref}>
      <div className="nat-input-row">
        <input
          className="nat-cod-input"
          type="text"
          placeholder="Cód."
          maxLength={6}
          value={localCod}
          style={aviso ? { borderColor: '#dc2626' } : undefined}
          onChange={e => { setLocalCod(e.target.value); setAviso('') }}
          onBlur={handleCodBlur}
          onKeyDown={e => { if (e.key === 'Enter') handleCodBlur() }}
        />
        <div className="nat-desc-box" onClick={() => setAberta(o => !o)}>
          {selecionado
            ? <span className="nat-dsc">{selecionado.ccu_des}</span>
            : <span className="nat-placeholder">Selecione ou digite o código...</span>
          }
          <span className="nat-chevron">{aberta ? '▴' : '▾'}</span>
        </div>
      </div>
      {aviso && <div style={{ fontSize: '0.75rem', color: '#dc2626', marginTop: '0.2rem', paddingLeft: '0.25rem' }}>{aviso}</div>}

      {aberta && posicao && createPortal(
        <div ref={listaRef} className="nat-lista" style={{ position: 'fixed', ...posicao, minWidth: posicao.width }}>
          <div className="nat-filtro-wrap">
            <input
              autoFocus
              className="nat-filtro"
              placeholder="Buscar por código ou descrição..."
              value={filtro}
              onChange={e => setFiltro(e.target.value)}
            />
          </div>
          <div className="nat-itens">
            {filtrada.length === 0 && <div className="nat-vazio">Nenhum resultado</div>}
            {filtrada.map(c => (
              <button
                key={c.ccu_cod}
                className={`nat-item${c.ccu_cod === value ? ' nat-item--ativo' : ''}`}
                onClick={() => selecionar(c)}
              >
                <div className="nat-item-linha1">
                  <span className="nat-item-cod">#{c.ccu_cod}</span>
                </div>
                <div className="nat-item-dsc">{c.ccu_des}</div>
              </button>
            ))}
          </div>
        </div>,
        document.body
      )}
    </div>
  )
}
